import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseButton',
  props: {
  mode: {
    type: String,
    required: false,
    default: null,
  },
  link: {
    type: Boolean,
    required: false,
    default: false,
  },
  to: {
    type: String,
    reuired: false,
    default: "/",
  },
},
  setup(__props) {

const props = __props;



const modeClass = props.mode != null ? "button--" + props.mode : "";

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (!__props.link)
    ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        class: _normalizeClass(["button", _unref(modeClass)])
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 2))
    : (_openBlock(), _createBlock(_component_router_link, {
        key: 1,
        class: _normalizeClass(["button", _unref(modeClass)]),
        to: __props.to
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["to", "class"]))
}
}

})